<template>
  <div class="war-report-root" v-if="warReportData.data !== undefined">
    <div class="war-report">
      <!--      <div class="left-top-triangle"></div>-->
      <div class="back" @click="callBackC"></div>

      <div class="top-bg">
        <div class="top-left-bg"></div>
        <div class="top-score">
          <div class="team-info">
            <img class="team-icon" :src="'/static/img/team_logo/'+ SelectScheduleList.teamA_name +'.png'"
                 :alt="SelectScheduleList.teamA_name">
            <div class="team-name">{{ SelectScheduleList.teamA_name }}</div>
            <div class="team-middle">
              <div class="team-score">
                <div class="win-count" :class="{'win': SelectScheduleList.winner === 'A'}">
                  {{ SelectScheduleList.scoreA }}
                </div>
                <div class="colon">:</div>
                <div class="win-count" :class="{'win': SelectScheduleList.winner === 'B'}">
                  {{ SelectScheduleList.scoreB }}
                </div>
              </div>
              <div class="win-year">{{ SelectScheduleList.date }} {{ SelectScheduleList.time }}</div>
              <div class="win-year win">已结束</div>
            </div>
            <div class="team-name">{{ SelectScheduleList.teamB_name }}</div>
            <img class="team-icon" :src="'/static/img/team_logo/'+SelectScheduleList.teamB_name+'.png'"
                 :alt="SelectScheduleList.teamB_name">
          </div>
        </div>

        <div class="number-of-sessions">
          <div class="menu-btn" @click="changeSessions(index)" v-for="(sessions,index) in warReportAllData"
               :key="sessions.id">
            <div class="menu-bg" :class="{active:sessionsIndex == index}"></div>
            <div class="menu-btn-title">{{ sessionsList[index] }}</div>
          </div>
        </div>
        <div class="top-right-bg"></div>
      </div>


      <div class="middle-detail disFlex">
        <div class="detail-left ml10">
          <div class="detail-left-top disFlex detail-right-top ml10">
            <img class="detail-icon" :src="'/static/img/team_logo/'+ warReportData.data.teamA.team.team_name +'.png'"
                 :alt="warReportData.data.teamA.team.team_name">
            <div class="detail-name">{{ warReportData.data.teamA.team.team_name }}</div>
          </div>
          <div class="detail-left-bottom disFlex ml10">
            <div class="detail-num disFlex">
              <div class="icon-detail"></div>
              <div class="icon-detail-name">
                <div class="icon-detail-label win">击杀数</div>
                <div class="icon-detail-num">{{ warReportData.data.teamA.team.kill }}</div>
              </div>
            </div>
            <div class="detail-num disFlex">
              <div class="icon-detail"></div>
              <div class="icon-detail-name">
                <div class="icon-detail-label win">首杀数</div>
                <div class="icon-detail-num">{{ warReportData.data.teamA.team.first }}</div>
              </div>
            </div>
            <div class="detail-num disFlex">
              <div class="icon-detail"></div>
              <div class="icon-detail-name">
                <div class="icon-detail-label win">队伍KD</div>
                <div class="icon-detail-num">{{ warReportData.data.teamA.team.KD }}</div>
              </div>
            </div>
            <div class="detail-num disFlex">
              <div class="icon-detail"></div>
              <div class="icon-detail-name">
                <div class="icon-detail-label win">伤害量</div>
                <div class="icon-detail-num">{{ warReportData.data.teamA.team.damage }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-center">
          <div class="disFlex">
            <div class="center-left"
                 :class="{'center-left-red': warReportData.win_team === warReportData.data.teamA.team.team_name, 'center-left-blue': warReportData.win_team === warReportData.data.teamB.team.team_name}">
              {{ warReportData.data.teamA.team.score }}
            </div>
            <div class="center-right"
                 :class="{'center-right-red': warReportData.win_team === warReportData.data.teamB.team.team_name, 'center-right-blue': warReportData.win_team === warReportData.data.teamA.team.team_name}">
              {{ warReportData.data.teamB.team.score }}
            </div>
          </div>
          <div style="padding: 5px 0;margin-left: 10px;">地图：{{ warReportData.map_name }}</div>
          <div class="detail-all" @click="showTeamDetail" style="margin-left: 108px">{{ showTeamDetailName }}</div>
        </div>

        <div class="detail-right" style="width: 418px;">
          <div class="detail-left-top disFlex fr" style="margin-right: 23px">
            <div class="detail-name mr20">{{ warReportData.data.teamB.team.team_name }}</div>
            <img class="detail-icon" :src="'/static/img/team_logo/'+ warReportData.data.teamB.team.team_name +'.png'"
                 :alt="warReportData.data.teamB.team.team_name">
          </div>
          <div class="clearfix"></div>
          <div class="detail-left-bottom disFlex fr" style="margin-left: 26px">
            <div class="detail-num disFlex">
              <div class="icon-detail-name textRight fr">
                <div class="icon-detail-label win">击杀数</div>
                <div class="icon-detail-num">{{ warReportData.data.teamB.team.kill }}</div>
              </div>
              <div class="icon-detail transformY180"></div>
            </div>
            <div class="detail-num disFlex">
              <div class="icon-detail-name textRight">
                <div class="icon-detail-label win">首杀数</div>
                <div class="icon-detail-num">{{ warReportData.data.teamB.team.first }}</div>
              </div>
              <div class="icon-detail transformY180"></div>
            </div>
            <div class="detail-num disFlex">
              <div class="icon-detail-name textRight">
                <div class="icon-detail-label win">队伍KD</div>
                <div class="icon-detail-num">{{ warReportData.data.teamB.team.KD }}</div>
              </div>
              <div class="icon-detail transformY180"></div>
            </div>
            <div class="detail-num disFlex">
              <div class="icon-detail-name textRight">
                <div class="icon-detail-label win">伤害量</div>
                <div class="icon-detail-num">{{ warReportData.data.teamB.team.damage }}</div>
              </div>
              <div class="icon-detail transformY180"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="team-detail" v-if="isShowTeamDetail">
          <div class="team-detail-top">
            <div class="team-list-icon"
                 v-for="(item, index) in warReportData.round"
                 :key="index" @click="changeRoundIndex(index)"
                 :class="{teamListIconRed: warReportData.win_team === item.win_team,teamListIconBlue: warReportData.win_team !== item.win_team, active: sessionsRoundIndex == index}"
            >
              <div>{{ index }}</div>
              <img v-if="item.win_way !== ''" :src="'/static/img/iframe/'+ item.win_way +'.png'" alt="">
            </div>
          </div>

          <div class="team-detail-bottom disFlex">
            <div class="team-detail-left">
              <div class="team-detail-logo">
                <img :src="'/static/img/team_logo/'+ warReportData.win_team +'.png'" :alt="warReportData.win_team">
                <div>WINNER</div>
              </div>
              <div class="team-detail-map1">
                <img :src="'/static/img/map_preview/'+ warReportData.map_name +'.png'" :alt=" warReportData.map_name">
                <div>{{ warReportData.map_name }}</div>
              </div>
              <!--              <div class="team-detail-map2">-->
              <!--                <img :src="'/static/img/map_preview/潜艇.png'" :alt="'潜艇'">-->
              <!--              </div>-->
            </div>

            <div class="team-detail-right ml42 mt20">
              <div class="disFlex" v-for="(item, index) in teamDetailA" :key="index">
                <div class="disFlex" v-if="index === 0">
                  <img class="team-detail-img1" :src="'/static/img/iframe/time1.png'">
                  <!--                  <div class="team-detail-time1">{{  `${item.time}`.substring(11,19)  }}</div>-->
                  <div class="team-detail-time1">{{ item.time | formatSeconds }}</div>
                  <img class="team-detail-star1" :src="'/static/img/iframe/time4.png'">
                  <div class="lineHeight10">{{ item.kill_name }}</div>
                  <img class="team-detail-gun1" :src="'/static/img/team_gun/gun.png'">
                  <div class="lineHeight10">{{ item.be_kill_name }}</div>
                </div>
                <div class="disFlex" v-else-if="index === teamDetailA.length - 1">
                  <img class="team-detail-img3" :src="'/static/img/iframe/time3.png'">
                  <!--                  <div class="team-detail-time3">{{  `${item.time}`.substring(11,19)  }}</div>-->
                  <div class="team-detail-time3">{{ item.time | formatSeconds }}</div>
                  <img class="team-detail-star3" :src="'/static/img/iframe/time4.png'">
                  <div class="lineHeight35">{{ item.kill_name }}</div>
                  <img class="team-detail-gun3" :src="'/static/img/team_gun/gun.png'">
                  <div class="lineHeight35">{{ item.be_kill_name }}</div>
                </div>
                <div class="disFlex" v-else>
                  <img class="team-detail-img2" :src="'/static/img/iframe/time2.png'">
                  <!--                  <div class="team-detail-time2">{{  `${item.time}`.substring(11,19)  }}</div>-->
                  <div class="team-detail-time2">{{ item.time | formatSeconds }}</div>
                  <img class="team-detail-star2" :src="'/static/img/iframe/time4.png'">
                  <div class="lineHeight40">{{ item.kill_name }}</div>
                  <img class="team-detail-gun2" style="" :src="'/static/img/team_gun/gun.png'">
                  <div class="lineHeight40">{{ item.be_kill_name }}</div>
                </div>
              </div>
            </div>

            <div class="team-detail-right ml42 mt20">
              <div class="disFlex" v-for="(item, index) in teamDetailB" :key="index">
                <div class="disFlex" v-if="index === 0">
                  <img class="team-detail-img1" :src="'/static/img/iframe/time1.png'">
                  <!--                  <div class="team-detail-time1">{{ `${item.time}`.substring(11,19)  }}</div>-->
                  <div class="team-detail-time1">{{ item.time | formatSeconds }}</div>
                  <img class="team-detail-star1" :src="'/static/img/iframe/time4.png'">
                  <div class="lineHeight10">{{ item.kill_name }}</div>
                  <img class="team-detail-gun1" :src="'/static/img/team_gun/gun.png'">
                  <div class="lineHeight10">{{ item.be_kill_name }}</div>
                </div>
                <div class="disFlex" v-else-if="index === teamDetailB.length - 1">
                  <img class="team-detail-img3" :src="'/static/img/iframe/time3.png'">
                  <!--                  <div class="team-detail-time3">{{  `${item.time}`.substring(11,19)  }}</div>-->
                  <div class="team-detail-time3">{{ item.time | formatSeconds }}</div>
                  <img class="team-detail-star3" :src="'/static/img/iframe/time4.png'">
                  <div class="lineHeight35">{{ item.kill_name }}</div>
                  <img class="team-detail-gun3" :src="'/static/img/team_gun/gun.png'">
                  <div class="lineHeight35">{{ item.be_kill_name }}</div>
                </div>
                <div class="disFlex" v-else>
                  <img class="team-detail-img2" :src="'/static/img/iframe/time2.png'">
                  <!--                  <div class="team-detail-time2">{{  `${item.time}`.substring(11,19)  }}</div>-->
                  <div class="team-detail-time2">{{ item.time | formatSeconds }}</div>
                  <img class="team-detail-star2" :src="'/static/img/iframe/time4.png'">
                  <div class="lineHeight40">{{ item.kill_name }}</div>
                  <img class="team-detail-gun2" style="" :src="'/static/img/team_gun/gun.png'">
                  <div class="lineHeight40">{{ item.be_kill_name }}</div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="clearfix"></div>


      <div class="bottom-table">
        <div class="header-column disFlex striped">
          <div class="player-column">选手</div>
          <div class="kill-column">击杀</div>
          <div class="death-column">死亡</div>
          <div class="hurt-column">伤害量</div>
          <div class="position-column">位置</div>
          <div class="hurt-column">伤害量</div>
          <div class="death-column">死亡</div>
          <div class="kill-column">击杀</div>
          <div class="player-column">选手</div>
        </div>
        <div>
          <div class="body-column disFlex" v-for="(item, index) in warReportData.data.teamA.player" :key="index"
               :class="{'striped':index % 2 !== 0, 'stripedBg': playerIndex === index, 'borderTopfabf8b':  playerIndex === index}">
            <div class="player-column textLeft disFlex">
              <img class="borderRight956840"
                   :src="'/static/img/team_preview/'+ warReportData.data.teamA.team.team_name +'/'+ item.nameStr +'.png'"
                   :alt="item.playerName">
<!--              <div class="" style="margin-left: 70px">{{ item.playerName }}</div>-->
              <div class="">{{ item.playerName }}</div>
            </div>
            <div class="kill-column">{{ item.kill }}</div>
            <div class="death-column">{{ item.death }}</div>
            <div class="hurt-column">{{ item.damage }}</div>
            <div class="position-column">
              <div class="position-top disFlex">
                <div>{{ item.Position }}</div>
                <div>{{ warReportData.data.teamB.player[index].Position }}</div>
              </div>
              <div class="detail-all" @click="showDetail(index)" v-if="playerIndex !== index">详情</div>
            </div>
            <div class="hurt-column">{{ warReportData.data.teamB.player[index].damage }}</div>
            <div class="death-column">{{ warReportData.data.teamB.player[index].death }}</div>
            <div class="kill-column">{{ warReportData.data.teamB.player[index].kill }}</div>
            <div class="player-column player-columnB textRight disFlex">
              <div>{{ warReportData.data.teamB.player[index].playerName }}</div>
              <img class="borderLeft956840"
                   :src="'/static/img/team_preview/'+ warReportData.data.teamB.team.team_name +'/'+ warReportData.data.teamB.player[index].nameStr +'.png'"
                   :alt="warReportData.data.teamB.player[index].playerName">
            </div>
            <div class="player-detail borderBottomfabf8b disFlex" v-if="index === playerIndex">
              <div class="player-detail-left">
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">KD</div>
                    <div class="fr left-top-player-num">{{ item.KD }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">首杀次数</div>
                    <div class="fr left-top-player-num">{{ item.first_kill }}</div>
                  </div>
                </div>
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">回合均击杀</div>
                    <div class="fr left-top-player-num">{{ item.round_kill }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">回合均伤害</div>
                    <div class="fr left-top-player-num">{{ item.round_damage }}</div>
                  </div>
                </div>
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">存活率</div>
                    <div class="fr left-top-player-num w67">{{ item.survival_rate+"%" }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">命中率</div>
                    <div class="fr left-top-player-num w67">{{ item.hit_rate }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">爆头率</div>
                    <div class="fr left-top-player-num w67">{{ item.headshot_rate+"%" }}</div>
                  </div>
                </div>
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">三杀</div>
                    <div class="fr left-top-player-num w67">{{ item.three_kill }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">四杀</div>
                    <div class="fr left-top-player-num w67">{{ item.four_kill }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">五杀</div>
                    <div class="fr left-top-player-num w67">{{ item.five_kill }}</div>
                  </div>
                </div>

              </div>


              <div class="player-detail-center">
                <div class="shouqi-icon"></div>
                <div class="detail-all shouqi-name" @click="hideDetail(index)">收起</div>
              </div>


              <div class="player-detail-right">

                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">KD</div>
                    <div class="fr left-top-player-num">{{ warReportData.data.teamB.player[index].KD }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">首杀次数</div>
                    <div class="fr left-top-player-num">{{ warReportData.data.teamB.player[index].first_kill }}</div>
                  </div>
                </div>
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">回合均击杀</div>
                    <div class="fr left-top-player-num">{{ warReportData.data.teamB.player[index].round_kill }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name">回合均伤害</div>
                    <div class="fr left-top-player-num">{{ warReportData.data.teamB.player[index].round_damage }}</div>
                  </div>
                </div>
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">存活率</div>
                    <div class="fr left-top-player-num w67">{{
                        warReportData.data.teamB.player[index].survival_rate+"%"
                      }}
                    </div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">命中率</div>
                    <div class="fr left-top-player-num w67">{{ warReportData.data.teamB.player[index].hit_rate }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">爆头率</div>
                    <div class="fr left-top-player-num w67">{{
                        warReportData.data.teamB.player[index].headshot_rate+"%"
                      }}
                    </div>
                  </div>
                </div>
                <div class="disFlex mt5">
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">三杀</div>
                    <div class="fr left-top-player-num w67">{{
                        warReportData.data.teamB.player[index].three_kill
                      }}
                    </div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">四杀</div>
                    <div class="fr left-top-player-num w67">{{ warReportData.data.teamB.player[index].four_kill }}</div>
                  </div>
                  <div class="player-detail-box-a disFlex w150">
                    <div class="left-top-player"></div>
                    <div class="win ml10 left-top-player-name w60">五杀</div>
                    <div class="fr left-top-player-num w67">{{ warReportData.data.teamB.player[index].five_kill }}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>

  </div>
</template>

<script>
import lodash from 'lodash'
import axios from "axios";
import {Loading} from "element-ui";
import {Api} from '@/api/config'

export default {
  name: "index",
  data: function () {
    return {
      sessionsIndex: 1,
      sessionsRoundIndex: 1,
      playerIndex: null,
      isShowTeamDetail: false,
      showTeamDetailName: '比赛详情',
      gameId: null,
      sessionsList: {
        1: '第一场',
        2: '第二场',
        3: '第三场',
        4: '第四场',
        5: '第五场',
      },
      warReportAllData: [],
      warReportData: [],
      player: [],
      teamDetail: [],
      teamDetailA: [],
      teamDetailB: [],
    }
  },
  props: {
    SelectScheduleList: Object,
  },
  created: function () {
    this.getGameOverData()
  },
  //vue过滤器filters,跟钩子函数平级
  filters: {
    //创建函数名formatSeconds
    formatSeconds(value) {
      let result = parseInt(value);

      let y =
        Math.floor(result / 86400) < 10
          ? "0" + Math.floor(result / 86400)
          : Math.floor(result / 86400);

      let h =
        Math.floor((result / 3600) % 24) < 10
          ? "0" + Math.floor((result / 3600) % 24)
          : Math.floor((result / 3600) % 24);

      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);

      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = "";
      // if (y !== "00") res += `${y}天`;

      // if (h !== "00") res += `${h}时`;

      res += `${m}:`;

      res += `${s}`;

      return res;
    },
  },
  computed: {},
  methods: {
    async getGameOverData() {
      await axios.get(Api.getGameOverData, {params: {game_id: this.SelectScheduleList.game_id}}).then((res) => {
        Loading.service({text: '加载中',})
        if (res.status === 200) {
          this.warReportAllData = res.data.data;
          this.sessionsIndex = 1
          this.sessionsRoundIndex = 1
          this.warReportData = this.warReportAllData[this.sessionsIndex]
          this.changeTeamName()
          this.warReportData.data.teamA.player.forEach((item, index) => {
            let nameArr = item.playerName.split('.')
            this.$set(this.warReportData.data.teamA.player[index], 'nameStr', nameArr[0])
          })
          this.warReportData.data.teamB.player.forEach((item, index) => {
            let nameArr = item.playerName.split('.')
            this.$set(this.warReportData.data.teamB.player[index], 'nameStr', nameArr[0])
          })
          this.changeRoundIndex(1)
        } else {
          this.$message.error('赛程请求失败1')
        }
      }).catch((error) => {
        log(error)
        this.$message.error('赛程请求失败2')
      }).finally(() => {
        this.$loading({}).close()
      })
    },
    changeSessions(index) {
      this.sessionsIndex = index;
      this.warReportData = this.warReportAllData[this.sessionsIndex]
      this.warReportData.data.teamA.player.forEach((item, index) => {
        let nameArr = item.playerName.split('.')
        this.$set(this.warReportData.data.teamA.player[index], 'nameStr', nameArr[0])
      })
      this.warReportData.data.teamB.player.forEach((item, index) => {
        let nameArr = item.playerName.split('.')
        this.$set(this.warReportData.data.teamB.player[index], 'nameStr', nameArr[0])
      })
      this.changeTeamName()
      this.changeRoundIndex(1)
      this.isShowTeamDetail = false
      this.playerIndex = null;
      this.sessionsRoundIndex = 1;
    },
    changeTeamName(){
      let teamNameA = this.warReportData.data.teamA.team.team_name
      if(teamNameA === 'EP.快手'){ this.warReportData.data.teamA.team.team_name = 'EP'; this.warReportData.win_team = 'EP' }
      if(teamNameA === 'KZ.斗鱼'){ this.warReportData.data.teamA.team.team_name = 'KZ'; this.warReportData.win_team = 'KZ' }
      if(teamNameA === 'Q9.快手'){ this.warReportData.data.teamA.team.team_name = 'Q9'; this.warReportData.win_team = 'Q9' }
      if(teamNameA === 'XROCK.斗鱼'){ this.warReportData.data.teamA.team.team_name = 'XROCK'; this.warReportData.win_team = 'XROCK' }
      if(teamNameA === '成都AG'){ this.warReportData.data.teamA.team.team_name = 'AG'; this.warReportData.win_team = 'AG' }
      if(teamNameA === '白鲨.斗鱼'){ this.warReportData.data.teamA.team.team_name = 'BS'; this.warReportData.win_team = 'BS' }

      let teamNameB = this.warReportData.data.teamB.team.team_name
      if(teamNameB === 'EP.快手'){ this.warReportData.data.teamB.team.team_name = 'EP'; this.warReportData.win_team = 'EP' }
      if(teamNameB === 'KZ.斗鱼'){ this.warReportData.data.teamB.team.team_name = 'KZ'; this.warReportData.win_team = 'KZ' }
      if(teamNameB === 'Q9.快手'){ this.warReportData.data.teamB.team.team_name = 'Q9'; this.warReportData.win_team = 'Q9' }
      if(teamNameB === 'XROCK.斗鱼'){ this.warReportData.data.teamB.team.team_name = 'XROCK'; this.warReportData.win_team = 'XROCK' }
      if(teamNameB === '成都AG'){ this.warReportData.data.teamB.team.team_name = 'AG'; this.warReportData.win_team = 'AG' }
      if(teamNameB === '白鲨.斗鱼'){ this.warReportData.data.teamB.team.team_name = 'BS'; this.warReportData.win_team = 'BS' }

    },
    changeRoundIndex(index) {
      this.sessionsRoundIndex = index;
      if (this.warReportData.kill[this.sessionsRoundIndex].length <= 9) {
        this.teamDetailA = this.warReportData.kill[this.sessionsRoundIndex].slice(0, this.warReportData.kill[this.sessionsRoundIndex].length)
        this.teamDetailB = []
      } else {
        this.teamDetailA = this.warReportData.kill[this.sessionsRoundIndex].slice(0, 9)
        this.teamDetailB = this.warReportData.kill[this.sessionsRoundIndex].slice(9, this.warReportData.kill[this.sessionsRoundIndex].length)
      }
    },
    showDetail(index) {
      this.playerIndex = index;
    },
    hideDetail() {
      this.playerIndex = null;
    },
    showTeamDetail() {
      this.isShowTeamDetail = !this.isShowTeamDetail;
      this.playerIndex = null;
      this.sessionsRoundIndex = 1;
      if (this.isShowTeamDetail) {
        this.showTeamDetailName = '收起';
      } else {
        this.showTeamDetailName = '比赛详情';
      }
    },
    callBackC() {
      this.$parent.callBack()
    }
  }
}
</script>

<style scoped>
.disFlex {
  display: flex;
}

.transformY180 {
  transform: rotateY(180deg);
}

.textRight {
  text-align: right;
}

.textLeft {
  text-align: left;
}

.fr {
  float: right;
}

.fl {
  float: left;
}

.lineHeight10 {
  line-height: 10px;
}

.lineHeight35 {
  line-height: 35px;
}

.lineHeight40 {
  line-height: 40px;
}

.mt5 {
  margin-top: 5px;
}

.mt20 {
  margin-top: 20px;
}

.ml5 {
  margin-left: 5px;
}

.ml10 {
  margin-left: 10px;
}

.ml30 {
  margin-left: 30px;
}

.ml42 {
  margin-left: 42px;
}

.mr20 {
  margin-right: 20px;
}

.mr29 {
  margin-right: 29px;
}

.mr32 {
  margin-right: 32px;
}

.mr42 {
  margin-right: 42px;
}

.pr30 {
  padding-right: 30px;
}

.pl30 {
  padding-left: 30px;
}

.w150 {
  width: 150px !important;
}

.w60 {
  width: 60px !important;
}

.w67 {
  width: 67px !important;
}

.borderLeft956840 {
  border-left: 1px solid #956840
}

.borderRight956840 {
  border-right: 1px solid #956840
}

.borderTopfabf8b {
  border-top: 1px solid #fabf8b
}

.borderBottomfabf8b {
  border-bottom: 4px solid #fabf8b
}


.war-report-root {
  /*width: 1400px;*/
  /*height: 800px;*/
  /*min-width: 100vw;*/
  /*min-height: 75vw;*/
  /*background-image: url("~@/assets/images/CFHL2022KV.png");*/
  /*background-size: cover;*/
  /*padding-top: 17px;*/
  color: #ffffff;
  margin: 0 auto;
  overflow-y: auto;
}

.war-report-root::-webkit-scrollbar {
  display: none;
}

.war-report {
  width: 1098px;
  min-height: 760px;
  margin: 0 auto;
  border: 1px solid #fabf8b;
  position: relative;
  background-image: url("~@/assets/images/2024CFPLPC.png");
  background-size: cover;
  background-position: -100px 0;
}

.top-bg {
  position: relative;
}

.top-left-bg {
  background-image: url("~@/assets/images/top-left-bg.png");
  background-size: cover;
  width: 421px;
  height: 175px;
  position: absolute;
  top: -10px;
  left: 80px;
}

.top-right-bg {
  background-image: url("~@/assets/images/top-right-bg.png");
  background-size: cover;
  width: 421px;
  height: 175px;
  position: absolute;
  top: -10px;
  left: 650px;
}

.left-top-triangle {
  background-image: url("~@/assets/images/triangle.svg");
  position: absolute;
  left: 3px;
  top: 3px;
  width: 12px;
  height: 12px;
  z-index: 8;
}

.back {
  background-image: url("~@/assets/images/back.png");
  position: absolute;
  left: 3px;
  top: 3px;
  width: 72px;
  height: 30px;
  z-index: 8;
  cursor: pointer;
}

.team-info {
  display: flex;
  align-items: center;
  width: 800px;
  margin: 12px auto;
}

.team-name {
  width: 150px;
  font-size: 35px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
}

.team-icon {
  width: 100px;
  height: 100px;
  margin: 0px 30px;
}

.team-middle {
  color: #ffffff;
}

.team-score {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 48px;
  margin: 10px 20px;
}

.win-count {
  width: 50px;
  height: 60px;
  line-height: 60px;
  font-size: 44px;
  font-weight: bold;
  background-image: url("~@/assets/images/winCount.png");
}

.win {
  color: #fabf8b;
}

.colon {
  width: 12px;
  height: 36px;
  line-height: 36px;
  font-size: 24px;
  font-weight: bold;
}

.number-of-sessions {
  margin-bottom: 10px;
}

.menu-btn {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 150px;
  height: 40px;
  margin: 0px 5px;
  cursor: pointer;
}

.menu-bg {
  z-index: 1;
  background-image: url(/static/img/iframe/sessionBg.png);
}

.menu-bg.active {
  background-image: url(/static/img/iframe/sessionBgA.png);
}

.menu-btn-title {
  text-shadow: 2px 2px 2px black;
  font-size: 16px;
  line-height: 40px;
  color: #ffffff;
  z-index: 2;
}

.menu-bg, .menu-btn-title {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}

.middle-detail {
  height: 88px;
  border-top: 1px solid #956840;
  border-bottom: 1px solid #956840;
  padding: 10px 0;
  position: relative;
}

.detail-left {
  width: 380px;
}

.detail-left-top {
  height: 43px;
}

.detail-icon {
  width: 38px;
  height: 38px;
  margin: 5px 20px 5px 0;
}

.detail-name {
  height: 43px;
  line-height: 43px;
  font-size: 20px;
  font-weight: bold;
}

.detail-left-bottom {
  margin-top: 5px;
}

.icon-detail {
  width: 10px;
  height: 20px;
  margin: 4px 8px 4px 8px;
  background-image: url(/static/img/iframe/icon-detail.png);
}

.icon-detail-num {
  font-size: 18px;
}

.detail-num {
  width: 107px;
  height: 40px;
  color: #ffffff;
  text-align: left;
}

.detail-center {
  width: 300px;
  padding: 5px 0;
}

.center-left {
  width: 187px;
  height: 34px;
  line-height: 34px;
  text-align: right;
  padding-right: 30px;
  font-size: 24px;
}

.center-left-red {
  color: #ff3222;
  background-image: url(/static/img/iframe/center-left-red.png);
}

.center-left-blue {
  color: #13a2e5;
  background-image: url(/static/img/iframe/center-left-blue.png);
}

.center-right {
  width: 156px;
  height: 34px;
  line-height: 34px;
  text-align: left;
  padding-left: 30px;
  font-size: 24px;
  margin-left: 10px;
  color: #13a2e5;
}

.center-right-red {
  color: #ff3222;
  background-image: url(/static/img/iframe/center-right-red.png);
}

.center-right-blue {
  color: #13a2e5;
  background-image: url(/static/img/iframe/center-right-blue.png);
}

.detail-all {
  width: 100px;
  height: 24px;
  line-height: 24px;
  background-image: url(/static/img/iframe/detail-all.png);
  margin: 0 auto;
  cursor: pointer;
}

.header-column {
  height: 30px;
  line-height: 30px;
  width: 1098px;
  border-bottom: 1px solid #956840;
}

.body-column {
  height: 70px;
  line-height: 70px;
  width: 1098px;
  border-bottom: 1px solid #956840;
  position: relative;
}

.striped {
  background-color: rgba(0, 0, 0, 0.3);
}

.stripedBg {
  background-color: rgba(0, 0, 0, 0.9);
}

.player-column {
  width: 220px;
}

.player-column img {
  width: 70px;
  height: 70px;
}

.player-column div {
  margin-left: 13px;
}

.player-columnB {
  position: relative;
}

.player-columnB img {
  position: absolute;
  right: 0;
}

.player-columnB div {
  position: absolute;
  right: 86px;
}

.kill-column {
  width: 102px;
}

.death-column {
  width: 102px;
}

.hurt-column {
  width: 102px;
}

.position-column {
  width: 185px;
}

.position-top {
  height: 35px;
  line-height: 35px;
}

.position-top div {
  width: 90px;
}

.player-detail {
  background-color: rgba(0, 0, 0, 0.9);
  position: absolute;
  top: 71px;
  width: 1098px;
  min-height: 178px;
  z-index: 999;
  font-size: 12px;
}

.player-detail-left {
  width: 466px;
  padding-left: 10px;
}

.player-detail-right {
  width: 466px;
  /*padding-right: 10px;*/
}

.player-detail-center {
  position: relative;
}

.player-detail-box-a {
  width: 221px;
  height: 36px;
  border: 1px solid #956840;
  line-height: 36px;
  position: relative;
  margin-right: 10px;
}

.left-top-player {
  background-image: url("~@/assets/images/left-top-player.png");
  position: absolute;
  left: 3px;
  top: 3px;
  width: 8px;
  height: 8px;
  z-index: 8;
}

.shouqi-icon {
  background-image: url("~@/assets/images/shouqi-icon.png");
  position: absolute;
  left: 43px;
  top: 120px;
  width: 60px;
  height: 16px;
  z-index: 8;
}

.shouqi-name {
  position: absolute;
  left: 23px;
  top: 140px;
  z-index: 8;
}

.left-top-player-name {
  width: 80px;
  text-align: left;
}

.left-top-player-num {
  width: 120px;
  text-align: right;
  font-weight: bold;
  font-size: 16px;
}

.player-detail-center {
  width: 186px;
}

.bottom-table {
  min-height: 483px;
}

.team-detail {
  width: 1039px;
  height: 460px;
  background-color: rgba(0, 0, 0, 0.9);
  position: absolute;
  top: 110px;
  z-index: 9999;
  padding: 10px 29px;
  text-align: left;
  border-bottom: 3px solid #fabf8b;
}

.team-list-icon {
  width: 56px;
  height: 80px;
  margin-right: 5px;
  margin-top: 5px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}

.teamListIconRed {
  background: url(/static/img/iframe/red-win.png);
  background-size: cover;
}

.teamListIconBlue {
  background: url(/static/img/iframe/blue-win.png);
  background-size: cover;
}

.teamListIconRed.active {
  background: url(/static/img/iframe/activeRed.png);
  background-size: cover;
}

.teamListIconBlue.active {
  background: url(/static/img/iframe/activeBlue.png);
  background-size: cover;
}

.team-list-icon div {
  width: 56px;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  font-size: 16px;
}

.team-list-icon img {
  width: 30px;
  height: 30px;
  margin-left: 12px;
}

.team-detail-logo, .team-detail-map1, .team-detail-map2 {
  width: 120px;
  height: 130px;
  border: 1px solid #fabf8b;
  margin-top: 10px;
}

.team-detail-logo img {
  width: 64px;
  height: 82px;
  margin-top: 10px;
  margin-left: 25px;
}

.team-detail-logo div {
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-weight: bold;

}

.team-detail-map1 {
  height: 80px !important;
}

.team-detail-map1 img {
  width: 120px;
  height: 63px;
}

.team-detail-map1 div {
  border-top: 1px solid #fabf8b;
  font-size: 12px;
  text-align: center;
}

.team-detail-map2 {
  height: 100px !important;
}

.team-detail-map2 img {
  width: 120px;
  height: 99px;
}

.team-detail-right {
  font-size: 12px;
}

.team-detail-img1 {
  width: 10px;
  height: 25px;
}

.team-detail-time1 {
  margin: 0 6px;
  line-height: 10px;
}

.team-detail-star1 {
  width: 9px;
  height: 8px;
  margin: 0 20px;
}

.team-detail-gun1 {
  width: 74px;
  height: 16px;
  margin: 0 20px;
}

.team-detail-img2 {
  width: 10px;
  height: 40px;
}

.team-detail-time2 {
  margin: 0 6px;
  line-height: 40px;
}

.team-detail-star2 {
  width: 9px;
  height: 8px;
  margin: 16px 20px 0;
}

.team-detail-gun2 {
  width: 74px;
  height: 16px;
  margin: 10px 20px 0;
}

.team-detail-img3 {
  width: 10px;
  height: 25px;
}

.team-detail-time3 {
  margin: 0 6px;
  line-height: 38px;
}

.team-detail-star3 {
  width: 9px;
  height: 8px;
  margin: 16px 20px 0;
}

.team-detail-gun3 {
  width: 74px;
  height: 16px;
  margin: 10px 20px 0;
}


@media only screen and (max-width: 751px) {
  .mobile-style {
    display: block
  }

  .war-report-root {
    width: 100vw;
    height: auto;
    min-height: 100vh;
    padding-top: .24rem;
    padding-bottom: .24rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iframe/matchSchedule/common/RegularSeason/warReport.vue